import type { ModelStatus } from '@partful/shared-types';
import { BadgeProps } from '@partful/shared/ui/Badge';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: string;
  variant: BadgeProps['variant'];
}

export function useProductCardStatusBadge({ modelStatus }: { modelStatus: ModelStatus }): StatusBadgeProps {
  const { t: tCommon } = useTranslation('common');

  switch (modelStatus) {
    case 'COMPLETED':
      return { status: tCommon('status.live'), variant: 'success' };
    /* istanbul ignore next - not currently used */
    case 'IN_PROGRESS':
      return { status: tCommon('status.inProgress'), variant: 'warning' };
    case 'DRAFT':
      return { status: tCommon('status.draft'), variant: 'default' };
    /* istanbul ignore next - not currently used */
    default:
      return { status: modelStatus, variant: 'default' };
  }
}
